import sanitizeHtml from 'sanitize-html'

export default (data: string): string => {
    const html = sanitizeHtml(data, {
        allowedTags: [...sanitizeHtml.defaults.allowedTags, 'img'],
        allowedAttributes: {
            ...sanitizeHtml.defaults.allowedAttributes,
            img: ['src', 'alt', 'width', 'height', 'loading', 'style', 'class', 'data-show'],
        },
        exclusiveFilter: (frame) => {
            if (frame.tag === 'img') return !('data-show' in frame.attribs)
            return false
        },
    })

    return html.replace(/<h3>Voucher już po minucie na Twoim e-mailu!<\/h3>/g, '')
        .replace(/<h2>Voucher już po minucie na Twoim e-mailu!<\/h2>/g, '')
        .replace(/<div><\/div>/g, '')
        .replace(/<p> <\/p>/g, '')
        .replace(/<b>/g, '')
        .replace(/<\/b>/g, '')
        .replace(/<br>/g, '')
}
